export interface EventLogFilter {
  take?: number;
  skip?: number;
  sort?: string | null | undefined;
  sortDirection?: string | null | undefined;
  userId?: string | null | undefined;
  actions?: string[] | null | undefined;
}

export const defaultEventLogsFilter = (): Partial<EventLogFilter> => {
  return {
    sort: "timestampUtc",
    sortDirection: "desc"
  };
};
